import { createSlice } from '@reduxjs/toolkit';

import type { NavigateOptions } from '@reach/router';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface AnchorSectionsState {
  isAnimating: boolean;
  sections: Record<string, NavigateOptions<unknown>>;
}

const initialState: AnchorSectionsState = {
  isAnimating: false,
  sections: {},
};

export const anchorSections = createSlice({
  initialState,
  name: 'anchorSections',
  reducers: {
    setIsAnimating: (state, { payload }: PayloadAction<boolean>) => {
      state.isAnimating = payload;
    },
    sectionAdd: (
      state,
      {
        payload: { id, options },
      }: PayloadAction<{
        id: string;
        options: NavigateOptions<unknown>;
      }>,
    ) => {
      state.sections[id] = options;
    },
    sectionRemove: (
      state,
      {
        payload: { id },
      }: PayloadAction<{
        id: string;
      }>,
    ) => {
      delete state.sections[id];
    },
  },
});
